// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SubnodeOutlinedSvg from "@fishx/icons-svg/es/asn/SubnodeOutlined";
import FishxIcon from '../components/FishxIcon';

var SubnodeOutlined = function SubnodeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SubnodeOutlinedSvg
  }));
};

SubnodeOutlined.displayName = 'SubnodeOutlined';
export default React.forwardRef(SubnodeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SubnodeOutlined.js
// module id = 4210
// module chunks = 0